import { useMemo } from "react";

import { styles } from "@repo/helpers";

import { Spinner } from "../spinner";
import style from "./style.module.scss";
import { Props } from "./types";

export function Loading(props: Props) {
	const defaultProps = { tag: "h1" } as Props;
	const { className, loading, inline = false, children, message = "Loading...", fullWidth = false, ...rest } = props;
	const spinnerClass = useMemo(() => styles(style.spinnerMessage, className), [className]);
	const containerClass = useMemo(
		() => styles(inline ? style.containerInline : style.container, fullWidth && style.fullWidth),
		[inline, fullWidth],
	);
	if (loading)
		return (
			<div className={containerClass}>
				<Spinner {...defaultProps} {...rest} className={spinnerClass}>
					{message}
				</Spinner>
			</div>
		);
	return <>{children}</>;
}
